module.exports = __webpack_public_path__ + "img/Hungary.350fca9c.png";